module.exports = __webpack_public_path__ + "img/img_8.7c614cb9.png";